module.exports = [
    {
        "term": "parasitoid of",
        "id": "RO_0002208"
    },
    {
        "term": "has parasitoid",
        "id": "RO_0002209"
    },
    {
        "term": "obligate parasite of",
        "id": "RO_0002227"
    },
    {
        "term": "facultative parasite of",
        "id": "RO_0002228"
    },
    {
        "term": "stem parasite of",
        "id": "RO_0002235"
    },
    {
        "term": "root parasite of",
        "id": "RO_0002236"
    },
    {
        "term": "hemiparasite of",
        "id": "RO_0002237"
    },
    {
        "term": "biotically interacts with",
        "id": "RO_0002437"
    },
    {
        "term": "trophically interacts with",
        "id": "RO_0002438"
    },
    {
        "term": "preys on",
        "id": "RO_0002439"
    },
    {
        "term": "symbiotically interacts with",
        "id": "RO_0002440"
    },
    {
        "term": "commensually interacts with",
        "id": "RO_0002441"
    },
    {
        "term": "mutualistically interacts with",
        "id": "RO_0002442"
    },
    {
        "term": "interacts with via parasite-host interaction",
        "id": "RO_0002443"
    },
    {
        "term": "parasite of",
        "id": "RO_0002444"
    },
    {
        "term": "parasitized by",
        "id": "RO_0002445"
    },
    {
        "term": "participates in a abiotic-biotic interaction with",
        "id": "RO_0002446"
    },
    {
        "term": "host of",
        "id": "RO_0002453"
    },
    {
        "term": "has host",
        "id": "RO_0002454"
    },
    {
        "term": "pollinates",
        "id": "RO_0002455"
    },
    {
        "term": "pollinated by",
        "id": "RO_0002456"
    },
    {
        "term": "acquires nutrients from",
        "id": "RO_0002457"
    },
    {
        "term": "preyed upon by",
        "id": "RO_0002458"
    },
    {
        "term": "is vector for",
        "id": "RO_0002459"
    },
    {
        "term": "has vector",
        "id": "RO_0002460"
    },
    {
        "term": "provides nutrients for",
        "id": "RO_0002469"
    },
    {
        "term": "eats",
        "id": "RO_0002470"
    },
    {
        "term": "is eaten by",
        "id": "RO_0002471"
    },
    {
        "term": "hyperparasite of",
        "id": "RO_0002553"
    },
    {
        "term": "hyperparasitized by",
        "id": "RO_0002554"
    },
    {
        "term": "allelopath of",
        "id": "RO_0002555"
    },
    {
        "term": "pathogen of",
        "id": "RO_0002556"
    },
    {
        "term": "has pathogen",
        "id": "RO_0002557"
    },
    {
        "term": "participates in a biotic-biotic interaction with",
        "id": "RO_0002574"
    },
    {
        "term": "visits",
        "id": "RO_0002618"
    },
    {
        "term": "visited by",
        "id": "RO_0002619"
    },
    {
        "term": "visits flowers of",
        "id": "RO_0002622"
    },
    {
        "term": "has flowers visited by",
        "id": "RO_0002623"
    },
    {
        "term": "lays eggs in",
        "id": "RO_0002624"
    },
    {
        "term": "has eggs laid in by",
        "id": "RO_0002625"
    },
    {
        "term": "kills",
        "id": "RO_0002626"
    },
    {
        "term": "is killed by",
        "id": "RO_0002627"
    },
    {
        "term": "ectoparasite of",
        "id": "RO_0002632"
    },
    {
        "term": "has ectoparasite",
        "id": "RO_0002633"
    },
    {
        "term": "endoparasite of",
        "id": "RO_0002634"
    },
    {
        "term": "has endoparasite",
        "id": "RO_0002635"
    },
    {
        "term": "mesoparasite of",
        "id": "RO_0002636"
    },
    {
        "term": "has mesoparasite",
        "id": "RO_0002637"
    },
    {
        "term": "intercellular endoparasite of",
        "id": "RO_0002638"
    },
    {
        "term": "has intercellular endoparasite",
        "id": "RO_0002639"
    },
    {
        "term": "intracellular endoparasite of",
        "id": "RO_0002640"
    },
    {
        "term": "has intracellular endoparasite",
        "id": "RO_0002641"
    },
    {
        "term": "epiphyte of",
        "id": "RO_0008501"
    },
    {
        "term": "has epiphyte",
        "id": "RO_0008502"
    },
    {
        "term": "kleptoparasite of",
        "id": "RO_0008503"
    },
    {
        "term": "kleptoparasitized by",
        "id": "RO_0008504"
    },
    {
        "term": "lays eggs on",
        "id": "RO_0008507"
    },
    {
        "term": "has eggs laid on by",
        "id": "RO_0008508"
    },
    {
        "term": "Interspecific interaction",
        "id": "GO_0044419"
    },
    {
        "term": "in competition with",
        "id": "INO_0000050"
    },
    {
        "term": "copulates with",
        "id": "NBO_0000060"
    },
    {
        "term": "Competitive exclusion",
        "id": "GO_0044402"
    },
    {
        "term": "feces eaten by",
        "id": "OMIT_0004607"
    },
    {
        "term": "disturbed by",
        "id": "ENVO_01000445"
    }

];